import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";
const HomeSliderService = {
    getHomeSliderData: async () => {
        try {
            const response = await axios.get(ApiConstants.getHomeSliderData);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateSliderData: async (
        sliderOneImage,
        sliderOneLink,
        sliderOneTitle,
        sliderOneDescription,
        sliderOneButtonTitle,
        sliderTwoImage,
        sliderTwoTitle,
        sliderTwoDescription,
        sliderTwoButtonTitle,
        sliderTwoLink,
        sliderThreeImage,
        sliderThreeTitle,
        sliderThreeDescription,
        sliderThreeButtonTitle,
        sliderThreeLink,
    ) => {
        try {
            const sliderdata = new FormData();
            sliderdata.append("sliderOneLink", sliderOneLink)
            sliderdata.append("sliderOneImage", sliderOneImage)
            sliderdata.append("sliderOneTitle", sliderOneTitle)
            sliderdata.append("sliderOneDescription", sliderOneDescription)
            sliderdata.append("sliderOneButtonTitle", sliderOneButtonTitle)
            sliderdata.append("sliderTwoLink", sliderTwoLink)
            sliderdata.append("sliderTwoImage", sliderTwoImage)
            sliderdata.append("sliderTwoTitle", sliderTwoTitle)
            sliderdata.append("sliderTwoDescription", sliderTwoDescription)
            sliderdata.append("sliderTwoButtonTitle", sliderTwoButtonTitle)
            sliderdata.append("sliderThreeLink", sliderThreeLink)
            sliderdata.append("sliderThreeImage", sliderThreeImage)
            sliderdata.append("sliderThreeTitle", sliderThreeTitle)
            sliderdata.append("sliderThreeDescription", sliderThreeDescription)
            sliderdata.append("sliderThreeButtonTitle", sliderThreeButtonTitle)
       
            const response = await axios.post(
                ApiConstants.updateSliderData,
                sliderdata,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateMobileBanner: async (
        uploadImageOne,
        uploadImageTwo,
        uploadImageThree,
        uploadMiddleImage,
        uploadLastImage
    ) => {
        try {
            const sliderdata = new FormData();
            sliderdata.append("uploadImageOne", uploadImageOne)
            sliderdata.append("uploadImageTwo", uploadImageTwo)
            sliderdata.append("uploadImageThree", uploadImageThree)
            sliderdata.append("uploadMiddleImage", uploadMiddleImage)
            sliderdata.append("uploadLastImage", uploadLastImage)         
       
            const response = await axios.post(
                ApiConstants.updateMobileBanner,
                sliderdata,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },


}
export default HomeSliderService;
